import { Injectable } from "@angular/core";
import { HttpInterClientService } from "./http-inter-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class InterService {
  constructor(private http: HttpInterClientService) {}

  public getInsurers(): Observable<any> {
    return this.http.post(`/api/insurance/insurers`, {}).pipe(tap((_) => console.log("InterService.getInsurers: Ok")));
  }

  public getModels(): Observable<any> {
    return this.http.post(`/api/insurance/models`, {}).pipe(tap((_) => console.log("InterService.getModels: Ok")));
  }

  public getBrands(year: number): Observable<any> {
    return this.http
      .post(`/api/insurance/brands`, { modelo: year })
      .pipe(tap((_) => console.log("InterService.getBrands: Ok")));
  }

  public getSubBrands(year: number, brand: string): Observable<any> {
    return this.http
      .post(`/api/insurance/subbrands`, { modelo: year, marca: brand })
      .pipe(tap((_) => console.log("InterService.getSubBrands: Ok")));
  }

  public getVersions(year: number, brand: string, type: string): Observable<any> {
    return this.http
      .post(`/api/insurance/versions`, { modelo: year, marca: brand, tipo: type })
      .pipe(tap((_) => console.log("InterService.getSubBrands: Ok")));
  }

  public getQuotes(quote_params: any): Observable<any> {
    return this.http
      .post(`/api/insurance/quote`, quote_params)
      .pipe(tap((_) => console.log("InterService.getQuotes: Ok")));
  }

  public getInterHomologatedVersions(data: any): Observable<any> {
    return this.http
      .post("/api/insurance/search/homologation", data)
      .pipe(tap((_) => console.log("InterService.getInterHomologatedVersions: Ok.")));
  }

  public getInterDescriptions(data: any): Observable<any> {
    return this.http
      .post("/api/insurance/search/description", data)
      .pipe(tap((_) => console.log("InterService.getInterDescriptions: Ok.")));
  }

  public emitPolicy(data: any): Observable<any> {
    return this.http
      .post("/api/insurance/emission", data)
      .pipe(tap((_) => console.log("InterService.emitPolicy: Ok.")));
  }
}
